module.exports = __webpack_public_path__ + "img/photo-41.53210aed.png";